import { api } from "../Api.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos equipamentos
 */
export class EquipamentRequests {
    /**
     * Faz a requisição para pegar o equipamento
     * @param {string} id do equipamento
     */
    async getEquipamento(id: string):Promise<any>{
        try {
            const response = await api.get(`/equipments/${id}`);
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar o equipamento
     * @param id id do equipamento a ser editado
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editEquipament(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/equipments/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar todos equipamentos
     */
    async getAllEquipaments(search: string, page: number):Promise<any>{
        try {
            let response = {
                data: []
            }
            if(page && search){
                response = await api.get(`/equipments?search=${search}&page=${page}`);
            }else if(page){
                response = await api.get(`/equipments?page=${page}`);
            }else{
                response = await api.get(`/equipments?search=${search}`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }


    /**
     * Faz a requisição para criação do equipamento
     * @param Body informações do equipamento
     * method-spoofing
     */
    async CreateEquipament(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/equipments`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz requisição para pegar a alocações que o usuário pode ver
     */
    async getlocations():Promise<any>{
        try {
            const response = await api.get(`/userAllocables`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getStates():Promise<any>{
        try {
            const response = await api.get(`/states`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getCities(uf: string):Promise<any>{
        try {
            const response = await api.get(`/states/${uf}/cities`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para excluir o equipamento
     * @param id id do equipamento a ser excluido
     */
    async deleteEquipament(id: string):Promise<any>{
        try {
            const response = await api.delete(`/equipments/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }


    /**
     * Faz a requisição para excluir o equipamento
     * @param Body id do equipamento a ser excluido
     */
    async EquipmentHistory(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/equipments/historicEquipment`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }


    /**
     * Faz a requisição para atualizar todos os equipamentos
     */
    async refreshAllEquipaments():Promise<any>{
        try {
            const response = await api.post(`/deleteJsons`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para atualizar o equipamento
     * @param id id do equipamento a ser atualizado
     */
    async refreshEquipament(id: string):Promise<any>{
        try {
            const response = await api.post(`/deleteJsons?id=${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
    
    /**
     * Faz a requisição para listar grupos de equipamentos
     * @param page paginação
     */
    async getAllGroups(search: string, page: number):Promise<any>{
        try {
            let response = {
                data: []
            }
            if(page && search){
                response = await api.get(`/grouppings?search=${search}&page=${page}`);
            }else if(page){
                response = await api.get(`/grouppings?page=${page}`);
            }else if(search){
                response = await api.get(`/grouppings?search=${search}`);
            }else{
                response = await api.get(`/grouppings`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para listar grupos de equipamentos
     * @param id id do usuário a ser excluido
     */
    async getGroup(id: string):Promise<any>{
        try {
            let response = await api.get(`/grouppings/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criar um grupo de equipamentos
     * @param Body dados do grupo
     */
    async createGroup(Body: FormData):Promise<any>{
        try {
            let response = await api.post(`/grouppings`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição alterar um grupo
     * @param id id do grupo
     * @param Body dados do grupo
     */
    async editGroup(id: string, Body: FormData):Promise<any>{
        try {
            let response = await api.post(`/grouppings/${id}`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Busca os equipamentos que o usuário pode ver
    async getAuthorizedEquipaments():Promise<any>{
        try {
            const response = await api.get(`/me/authorizedEquipments`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Adiciona um equipamento a um grupo
     * @param idGroup id do grupo
     * @param idEquipment dados do grupo
     */
    async addEquipamentToGroup(idGroup: string, idEquipment: string):Promise<any>{
        try {
            let response = await api.post(`/grouppings/${idGroup}/equipments/${idEquipment}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Remove um equipamento de um grupo
     * @param idGroup id do grupo
     * @param idEquipment dados do grupo
     */
    async removeEquipamentFromGroup(idGroup: string, idEquipment: string):Promise<any>{
        try {
            let response = await api.delete(`/grouppings/${idGroup}/equipments/${idEquipment}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para excluir o grupo
     * @param id id do grupo a ser excluido
     */
    async deleteGroup(id: string):Promise<any>{
        try {
            const response = await api.delete(`/grouppings/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
    
    /**
     * Faz a requisição para salvar areas de abastecimento
     * @param {Array} areas coordenadas das areas a serem salvas
     */
    async saveArea(areas: Array<Array<number>>):Promise<any>{
        try {
            const response = await api.post(`/equipments/storeMultSupplyAreas`, [areas]);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para salvar areas de abastecimento
     * @param {string} id ID da área a ser editada
     * @param {Object} area areas a serem editadas
     * method-spoofing
     */
    async editArea(id: string, area: Object):Promise<any>{
        try {
            const response = await api.patch(`/equipments/supplyAreas/${id}`, area);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para linkar o equipamento a uma área
     * @param {string} id id do equipamento
     * @param {string} areaid id da área a ser linkada
     */
    async linkEquipamentToArea(id: string, areaid: string):Promise<any>{
        try {
            const response = await api.post(`/equipments/addSupplyAreas`, [{
                "target": id,
                "supplys": [areaid]
            }]);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para linkar o equipamento a uma área
     * @param {string} id id do equipamento
     * @param {string} areaid id da área a ser removida
     */
    async removeLinkEquipamentFromArea(id: string, areaid: string):Promise<any>{
        try {
            const response = await api.post(`/equipments/removeSupplyAreas`, [{
                "target": id,
                "supplys": [areaid]
            }]);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar as áreas de abastecimento
     * @param {string} id id do equipamento
     */
    async getAreas(id: string):Promise<any>{
        try {
            const response = await api.get(`/equipments/supplyAreas/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar as áreas de abastecimento
     */
    async getAllAreas():Promise<any>{
        try {
            const response = await api.get(`/equipments/supplyAreas/show`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para salvar linhas de abastecimento
     * @param {Object} Item das areas a serem salvas
     */
    async saveLine(Item: Object):Promise<any>{
        try {
            const response = await api.post(`/equipments/supplyLines`, Item);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para salvar linhas de abastecimento
     * @param {string} id id da linha a ser editada
     * @param {Object} Lines das areas a serem salvas
     */
    async editLine(id: string, Lines: Object):Promise<any>{
        try {
            const response = await api.patch(`/equipments/supplyLines/${id}`, Lines);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar as linhas de abastecimento
     * @param {string} id id do equipamento
     */
    async getLines(id: string):Promise<any>{
        try {
            const response = await api.get(`/equipments/showSupplyLines/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para excluir uma linha de abastecimento
     * @param {string} id id da linha a ser excluida
     */
    async DeleteLine(id: string):Promise<any>{
        try {
            const response = await api.delete(`/equipments/supplyLines/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}